export enum FEATURE_FLAGS {
  ENABLE_LANGUES_DEMO_SIMPLE_CARDS = "mw-langues-demo-simple-cards",
  ENABLE_VOICES_SLIDER_NO_AUTOSCROLL = "mw-voices-slider-no-autoscroll",
  ENABLE_VOICE_CHANGER_SOFT_NUDGE = "mw-voice-changer-soft-nudge",
  ENABLE_VOICE_CHANGER_SOFT_NUDGE_V2 = "mw-voice-changer-soft-nudge-v2",
  ENABLE_VOICE_CLONING_SOFT_NUDGE = "mw-voice-cloning-soft-nudge",
  ENABLE_VOICE_CLONING_SOFT_NUDGE_V2 = "mw-voice-cloning-soft-nudge-v2",
  ENABLE_NAV_CTA_TEST = "mw-default-add-contact-sales-to-contextual-nav",
  ENABLE_SFX_CATEGORY_V2 = "mw-sfx-category-v2-iteration-4",
  ENABLE_MUSIC_CATEGORY_V2 = "mw-music-category-v2",
  ENABLE_TTS_LANGUAGE_SIGNUP_POPOVER = "mw-tts-language-singup-pover-2",
  ENABLE_ELVENLABS_PAGE = "mw-elvenlabs-page",
  ENABLE_SFX_EXPLORE_UX_IMPROVEMENTS_1 = "mw-sfx-explore-ux-improvements-1",
  ENABLE_NAV_GO_TO_APP_LOGIN = "mw-nav-go-to-app-login",
}
